export interface DropdownOption {
  id: any;
  code?: string;
  text: string;
  keywords?: string;
  relatedId?: number | null;
  description?: string | null;
}

export enum DropDownKeywords {
  TypeIdentification = "TypeIdentification",
  Countries = "Countries",
  Provinces = "Provinces",
  Cities = "Cities",
  MaritalStatus = "MaritalStatus",
  EconomicActivity = "EconomicActivity",
  NationalityId = "Nationality",
  Sex = 'Sex',
  SalaryExpectations = 'SalaryExpectations',
  Skills = 'Skills',
  SoftSkills = 'SoftSkills',
  TechnicalSkills = 'TechnicalSkills',
  SkillLevels = 'SkillLevels',
  Languages = 'Languages',
  LanguageLevels = 'LanguageLevels',
  ContractTypes = 'ContractTypes',
  JobOfferStatuses = 'JobOfferStatuses',
  TravelDisponibilities = 'TravelDisponibilities',
  WorkExperienceLevels = 'WorkExperienceLevels',
  QuickFilters = 'QuickFilters',
  JobApplicationMethods = 'JobApplicationMethods',
  JobContractDurations = 'JobContractDurations',
  RemoteWorkPossibilities = 'RemoteWorkPossibilities',
  Certifications = 'Certifications',
  EducationLevels = 'EducationLevels',
  ResumeTemplates = 'ResumeTemplates',
  ResumeEducationStatus = 'ResumeEducationStatus',
  Departments = 'Departments',
  Positions = 'Positions',
  JobBenefits = 'JobBenefits',
  GeneralJobRequirements = 'GeneralJobRequirements',
  ChargeTypes = 'ChargeTypes',
  ProfessionalProfiles = 'ProfessionalProfiles',
  Universities = 'Universities',
  Careers = 'Careers',
  UserCompanies = 'UserCompanies',
  Companies = 'Companies',
  JobOfferStats = 'JobOfferStats',
  JobApplicationsCount = 'JobApplicationsCount',
  AvailableServices = 'AvailableServices',
  Districts = 'District',
  Services = 'Services',
  PeriodUnit = 'PeriodUnit',
  FaIcons = 'FaIcons',
  FunctionalType = 'FunctionalType'
}
